<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="blockquote-container prose without-attribution">
<blockquote class="prose without-attribution">
<p class="first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last dedication-content">This book is dedicated to single mothers everywhere. Being a single mom is the toughest job out there‍—I would know. Keep putting your children first, and God will bless you for it.</p>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?40c1ab0c